import { observer } from 'mobx-react';

import { useCountdownTimer } from '../../../hooks/useCountdownTimer';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface QuestWidgetTimerProps {
  endDate: Date;
  onEnd: () => void;
  extended?: boolean;
}

function QuestWidgetTimerComponent(props: QuestWidgetTimerProps) {
  const { onEnd, extended, endDate } = props;

  const { timer } = useCountdownTimer({ endDate, onEnd });

  return <GeneralWidgetTimer extended={extended} timerValue={timer} />;
}

export const QuestWidgetTimer = observer(QuestWidgetTimerComponent);
